module.exports = require("core-js-pure/stable/instance/map");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/instance/map.js
// module id = 587
// module chunks = 168707334958949